module.exports = __webpack_public_path__ + "static/img/2.b7ae5001.jpg";